<!--
 * @Description: 
 * @Date: 2025-06-22 11:08:41
 * @LastEditors: function
 * @LastEditTime: 2025-10-23 17:36:43
 * @FilePath: \protal-web\src\views\news\details.vue
-->
<template>
  <div class="bgff">
    <div><img src="@/assets/images/banner4.png" class="banner" /></div>
    <div class="contList">
      <div class="w1000">
        <div class="breadcrumb">
          <span class="cl00" @click="$goRouter('/')">首页</span>
          <span>></span>
          <span class="cl00" @click="$goRouter('/news/list')">新闻资讯</span>
          <span>></span>
          <span>详情</span>
        </div>
        <div class="title">{{ details.infoTitle }}</div>
        <div class="mt5 fs18 cl7b borb">
          发布时间: {{ details.publishTime }}
        </div>
        <div
          class="mt10 fs18 detail-content"
          v-html="details.infoContent"
          v-show="!loading"
        ></div>
        <div class="mt10 fs18 detail-content loading-back" v-if="loading">
          <div class="loading-img"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoDetail } from "@/api/news";
export default {
  name: "details",
  data() {
    return {
      details: {},
      loading: true,
    };
  },
  mounted() {
    this.getInfoDetails();
  },
  methods: {
    async getInfoDetails() {
      const id = this.$route.query.id;
      const { data } = await getInfoDetail({ id });
      this.details = data;
      this.loading = false;
    },
  },
};
</script>


<style scoped lang="less">
.w1000 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
}
.banner {
  width: 100%;
  height: 260px;
  object-fit: cover;
}
.contList {
  height: 100%;
  .title {
    font-weight: 700;
    font-size: 32px;
  }
}
.borb {
  border-bottom: 1px solid rgb(238, 237, 237);
  padding-bottom: 10px;
}

.detail-content {
  min-height: calc(100vh - 200px);
  padding-bottom: 20px;
  overflow-y: auto;
}

.loading-back {
  background: rgba(228, 214, 214, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-img {
  width: 32px;
  height: 32px;
  background: url("../../assets/images/loading.png")no-repeat center;
  background-size: cover;
  animation: rotateAnimation 2.5s linear infinite;
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>